import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Rocket, X, Wallet } from 'lucide-react';
import { Button } from './ui/button';
import { useGameWallet } from '../providers/GameWalletProvider';
import { useNavigate } from 'react-router-dom';

const OnboardingBanner = () => {
  const { showOnboarding, dismissOnboarding } = useGameWallet();
  const navigate = useNavigate();

  const handleDeposit = () => {
    dismissOnboarding();
    navigate('/shop');
  };

  return (
    <AnimatePresence>
      {showOnboarding && (
        <motion.div
          className="fixed bottom-20 left-4 right-4 z-40 max-w-2xl mx-auto"
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 50 }}
          transition={{ type: 'spring', stiffness: 300, damping: 30 }}
        >
          <div className="relative bg-gradient-to-r from-purple-900/90 via-pink-900/90 to-orange-900/90 backdrop-blur-lg border-2 border-pink-500/50 rounded-2xl p-4 shadow-2xl shadow-pink-500/20">
            {/* Close Button */}
            <button
              onClick={dismissOnboarding}
              className="absolute top-2 right-2 p-1.5 hover:bg-white/10 rounded-lg transition-colors"
            >
              <X className="w-5 h-5 text-white/60 hover:text-white" />
            </button>

            <div className="flex items-center gap-4">
              {/* Icon */}
              <motion.div
                className="flex-shrink-0 w-12 h-12 rounded-xl bg-gradient-to-br from-yellow-500 to-orange-500 flex items-center justify-center"
                animate={{ 
                  rotate: [-5, 5, -5],
                  scale: [1, 1.05, 1]
                }}
                transition={{ duration: 2, repeat: Infinity }}
              >
                <Rocket className="w-6 h-6 text-white" />
              </motion.div>

              {/* Content */}
              <div className="flex-1 min-w-0">
                <h4 className="font-anton text-lg text-white mb-1">
                  <span className="text-yellow-400">NEW:</span> Instant Play!
                </h4>
                <p className="text-sm text-white/70 leading-tight">
                  Deposit SOL/Tokens once, play forever without pop-ups. Your funds are always safe.
                </p>
              </div>

              {/* Buttons */}
              <div className="flex-shrink-0 flex flex-col gap-2">
                <Button
                  onClick={handleDeposit}
                  className="h-10 px-4 bg-gradient-to-r from-green-500 to-emerald-500 hover:from-green-400 hover:to-emerald-400 text-black font-bold text-sm rounded-lg"
                  data-testid="onboarding-deposit-btn"
                >
                  <Wallet className="w-4 h-4 mr-1" />
                  DEPOSIT
                </Button>
                <Button
                  onClick={dismissOnboarding}
                  variant="ghost"
                  className="h-8 px-4 text-white/60 hover:text-white hover:bg-white/10 text-xs"
                  data-testid="onboarding-dismiss-btn"
                >
                  Dismiss
                </Button>
              </div>
            </div>

            {/* Progress bar animation */}
            <motion.div
              className="absolute bottom-0 left-0 h-1 bg-gradient-to-r from-cyan-400 to-pink-400 rounded-b-2xl"
              initial={{ width: '100%' }}
              animate={{ width: '0%' }}
              transition={{ duration: 15, ease: 'linear' }}
              onAnimationComplete={dismissOnboarding}
            />
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default OnboardingBanner;
